import { morph } from "web-ui/morphdom/morph"

function morphdomRender({ detail }) {
  detail.render = (fromElement, toElement) => {
    morph(fromElement, toElement, { childrenOnly: true })
  }
}

export function activate() {
  addEventListener("turbo:before-frame-render", morphdomRender)
}
